import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Bike, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const links = [
  { to: "/", label: "Home" },
  { to: "/bikes", label: "Hire a Bike" },
  { to: "/book", label: "Book" },
  { to: "/self-guided", label: "Self-Guided" },
  { to: "/admin", label: "Admin" },
];

export const Navbar = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const isActive = (to) => (to === "/" ? pathname === "/" : pathname.startsWith(to));
  const slug = (label) => label.toLowerCase().replace(/\s/g, "-");

  return (
    <header
      data-testid="main-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#F5F5F0]/80 border-b border-black/10"
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between gap-3">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group shrink-0">
          <span className="w-9 h-9 rounded-full bg-[#001A4D] flex items-center justify-center shrink-0">
            <Bike className="w-5 h-5 text-[#F5F5F0]" strokeWidth={1.5} />
          </span>
          <span className="font-serif text-lg sm:text-2xl font-semibold tracking-tight text-[#0A0A0A] whitespace-nowrap">
            Whangamatā Cycles
          </span>
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-1 md:gap-2">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${slug(l.label)}`}
              className={`px-3 md:px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                isActive(l.to)
                  ? "bg-[#001A4D] text-[#F5F5F0]"
                  : "text-[#0A0A0A]/70 hover:text-[#0A0A0A] hover:bg-black/5"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        {/* Mobile menu */}
        <div className="md:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button data-testid="mobile-menu-btn" aria-label="Open menu" className="p-2 rounded-full hover:bg-black/5 transition-colors">
                <Menu className="w-6 h-6 text-[#0A0A0A]" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#F5F5F0] w-72 border-l border-black/10">
              <div className="flex flex-col gap-2 mt-10">
                {links.map((l) => (
                  <Link
                    key={l.to}
                    to={l.to}
                    onClick={() => setOpen(false)}
                    data-testid={`mobile-nav-${slug(l.label)}`}
                    className={`px-4 py-3 rounded-xl text-base font-medium transition-colors ${
                      isActive(l.to)
                        ? "bg-[#001A4D] text-[#F5F5F0]"
                        : "text-[#0A0A0A]/80 hover:bg-black/5"
                    }`}
                  >
                    {l.label}
                  </Link>
                ))}
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </nav>
    </header>
  );
};
